import L from "leaflet";

export const langKey = "lang";
const defaultLang = "ar";
export const tokenKey = "token";
export const getToken = () => localStorage.hasOwnProperty(tokenKey) ? localStorage.getItem(tokenKey) : null;
export const getLang = () => localStorage.hasOwnProperty(langKey) ? localStorage.getItem(langKey) : defaultLang;

export const toggleLoader = (loaderId) => {
    let loader = document.getElementById(loaderId);
    if (!loader) {
        return;
    }
    loader.classList.contains('hidden') ? loader.classList.remove("hidden") : loader.classList.add("hidden");
}


export function LocationObject(lat, lng) {
    this.latitude = lat;
    this.longitude = lng;
}

export function getKeyByValue(object, value) {
    return Object.keys(object).find(key => object[key] === value);
}

export const parsePolygon = (polyAsString) => {  //return array of latLngs
    const polyWithoutPrefix = polyAsString.slice(9);
    const polyPureString = polyWithoutPrefix.substr(0, polyWithoutPrefix.length - 2)
    const latlngsUnordered = polyPureString.split(",");
    return latlngsUnordered.map((item, index) => {
        const arrayOfLatLng = item.split(" ").map(singleCoord => parseFloat(singleCoord));
        return [arrayOfLatLng[1], arrayOfLatLng[0]];
    });
}

export function isMarkerInsidePolygon(x, y, poly) {
    var inside = false;
    for (var ii = 0; ii < poly.getLatLngs().length; ii++) {
        var polyPoints = poly.getLatLngs()[ii];
        for (var i = 0, j = polyPoints.length - 1; i < polyPoints.length; j = i++) {
            var xi = polyPoints[i].lat, yi = polyPoints[i].lng;
            var xj = polyPoints[j].lat, yj = polyPoints[j].lng;
            var intersect = ((yi > y) != (yj > y))
                && (x < (xj - xi) * (y - yi) / (yj - yi) + xi);
            if (intersect) inside = !inside;
        }
    }

    return inside;
};
export const addPolygon = (arrayOfLatLng, map) => {
    const polygonObject = L.polygon(arrayOfLatLng, {color: 'red'}).addTo(map);
    map.fitBounds(polygonObject.getBounds());
}
export const debounce = (wait, callback) => {
    if (window.timeout) {
        clearTimeout(window.timeout);
    }
    window.timeout = setTimeout(() => {
        callback();
        window.timeout = null;
    }, wait);
}
export const fullAddressKeys = ["location", "reference_point", "district_id"];




